import { setChartofAcct, fetchCoaInfo } from '../../services';
import { useAppContext } from '../../context/AppContext';
import { useState, useEffect } from 'react';

export const ChartOfAccounts = ({ onSuccess }) => {
  const { base_url, token } = useAppContext();
  const [accounts, setAccounts] = useState({ income: [], cogs: [], assets: [] });

  useEffect(() => {
    fetchCoaInfo(base_url, token, setAccounts);
  }, [base_url, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      income: document.getElementById('revenue_account').value,
      cost: document.getElementById('expense_account').value,
      asset: document.getElementById('inventory_account').value
    };
    setChartofAcct(base_url, token, formData, onSuccess);
  };

  return (
    <div>
      <div className="step-header">
        <h2>Chart of Accounts</h2>
        <p>Map your revenue, expense, and inventory accounts for Slipstream.</p>
      </div>

      <form onSubmit={handleSubmit} className="form-section">
        <div className="form-group">
          <label className="form-label" htmlFor="revenue_account">Revenue account</label>
          <select id="revenue_account" name="revenue_account" className="form-select" defaultValue="">
            <option value="">Please select</option>
            {accounts.income?.map(account => (
              <option key={account.Id} value={account.Id}>{account.Name}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="expense_account">Expense account</label>
          <select id="expense_account" name="expense_account" className="form-select" defaultValue="">
            <option value="">Please select</option>
            {accounts.cogs?.map(account => (
              <option key={account.Id} value={account.Id}>{account.Name}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="inventory_account">Inventory account</label>
          <select id="inventory_account" name="inventory_account" className="form-select" defaultValue="">
            <option value="">Please select</option>
            {accounts.assets?.map(account => (
              <option key={account.Id} value={account.Id}>{account.Name}</option>
            ))}
          </select>
        </div>
        <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
          Save Chart of Accounts
        </button>
      </form>
    </div>
  );
};
